export enum CaseType {
	GENERIC = 0,
	PROPOSAL_INSURANCE_GUARANTEE = 1,
	PROPOSAL_INSURANCE_GUARANTEE_CONTRACT = 3,
	CASE_OCCURRENCE = 4,
	CASE_DEAL = 5,
	CASE_OCCURRENCE_EVICTION = 6,
	CASE_COLLECTION = 7,
	CASE_REAL_ESTATE_PROPOSAL = 8,
	CASE_INSURANCE_GUARANTEE_CONTRACT_RENEW = 9,
	CASE_PROPOSAL_INSURANCE_GUARANTEE_EXPRESS = 10,
	CASE_PORTABILITY_INSURANCE_GUARANTEE = 11,
	CASE_DEAL_IN_COURT = 12,
	CASE_DEAL_OUT_OF_COURT = 13,
	CASE_DEAL_SEPARATE = 14,
	CASE_FIRE_INSURANCE = 15,
	CASE_SURETY_INSURANCE = 16,
}
